export enum ReleaseNotesType {
  None = 'None',
  Consumer = 'Consumer',
  Pro = 'PRO',
}

export enum AlarmStatus {
  Active = 'Active',
  DismissedByDevice = 'DismissedByDevice',
  ResetByUserOnDevice = 'ResetByUserOnDevice',
  ResetByUserFromCloud = 'ResetByUserFromCloud',
}

export type Region = {
  name: string;
  code?: string;
};

export type Country = {
  name: string;
  regions?: Region[];
  countryCode: string;
  countryCode2Alpha: string;
  countryCode3Alpha: string;
};

export type Address = {
  id?: string;
  city: string;
  country: Country;
  lineOne: string;
  lineTwo: string;
  postalCode: string;
  region: string;
};

export type DropdownCountry = Country & {
  regions?: { name: string; code: string }[];
};

export type Translation = {
  id: string;
  defaultMessage: string;
};

export type FirmwareVersion = {
  version: string;
  created: string;
  fileName: string;
  sha256sum: string;
  uri: string;
  isDesired: boolean;
  downloadCount: number;
  fileSize: number;
  hasReleaseNotesFor?: ReleaseNotesType;
};

export type Firmware = {
  firmwareTypeId: string;
  name: string;
  description: string;
  brandId: string;
  companyId: string;
  visibility: boolean;
  visibilityInApps: boolean;
  versions: FirmwareVersion[];
};
